const weburl =  'http://ccyy.jsltpct.cn/ltxt/img/server/';//zs
// const printurl = 'http://ltcczx.tzpdg.top';//cs
const printurl = 'http://zxyy.jsltpct.cn';//市场端URL

export default
{
 weburl,printurl
}
